import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { UpdateMyClientDto } from '@ansvar-sakerhet/api-client';
import { toast } from '../../../components/Toast';
import { clientKeys } from './client.key';

export function useUpdateClientMe() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async (data: UpdateMyClientDto) => {
    const api = await getApi();
    const res = await api.clientsUpdateMe(data);
    return res.data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: clientKeys.all });
      toast.success('Organisationsuppgifter uppdaterade');
    },
    onError: () => toast.error('Något gick fel'),
  });
}
